/**
 * @file 子路由渲染组件
 * @author cuibolun<cuibolun@baijia.com>
 * @date 2020-02-24
 */
import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
// @ts-ignore
import {joinPath} from '~/utils/url';

export default function SubRoutes(props: any) {
    const {routes} = props;

    return (
        <Switch>
            {
                routes.map((route: any) => {
                    const {match: {path}} = props;
                    const {path: subPath = '', component, exact = true, subRoutes = [], redirect, slot} = route;
                    const key = joinPath(path, subPath);

                    if (redirect) {
                        return <Redirect key={key} to={redirect} />;
                    }
                    const Component = component;
                    if (subRoutes.length) {
                        const render = (props: any) => {
                            if (!Component) {
                                return <SubRoutes {...props} routes={subRoutes} />;
                            }

                            if (slot) {
                                return (
                                    <Component {...props} routeConfig={route}>
                                        <SubRoutes {...props} routes={subRoutes} />
                                    </Component>
                                );
                            }

                            return [
                                <Component {...props} key="parent" routeConfig={route} />,
                                <SubRoutes {...props} key="children" routes={subRoutes} />
                            ];
                        };

                        return (
                            <Route
                                {...props}
                                exact={exact}
                                key={key}
                                path={key}
                                // eslint-disable-next-line react/jsx-no-bind
                                render={render}
                            />
                        );
                    }

                    const render = (props: any) => <Component {...props} routeConfig={route} />;

                    return (
                        // eslint-disable-next-line react/jsx-no-bind
                        <Route {...props} exact={exact} key={key} path={key} render={render} />
                    );

                })
            }
        </Switch>
    );
}
